import { ReactNode } from "react";
import { MosaicTrafficLightClass } from "../traffic-lights/MosaicTrafficLightClass";
import { AitRowGroupData } from "./functions/AitRowGroupData";
import {
  AitHeaderGroupData,
  AitLocationBodyRowGroup,
  AitLocationHeader,
} from "./functions/interface";
import { trGetPositionFromLocation } from "./functions/trGetPositionFromLocation";
import { useTableContext } from "./TableContextProvider";

interface AitRowGroupTrafficLightProps {
  location: AitLocationHeader | AitLocationBodyRowGroup;
}

/**
 * Render a traffic light for a row group when applicable.
 *
 * @template T - Row group payload type
 * @param props - Component props
 * @param props.location - The header or body row-group location
 */
export const AitRowGroupTrafficLight = <T,>({
  location,
}: AitRowGroupTrafficLightProps): ReactNode => {
  const { state } = useTableContext<T>();
  const thisRowGroup: AitHeaderGroupData<T> | AitRowGroupData<T> | undefined =
    trGetPositionFromLocation(state, location, true).data;

  const coreTrafficLight = thisRowGroup?.coreTrafficLight ?? "BlankNotEvaluated";

  return !state?.noTrafficLights && coreTrafficLight !== "BlankNotEvaluated"
    ? new MosaicTrafficLightClass(coreTrafficLight, "4px", "-16px").element
    : null;
};

AitRowGroupTrafficLight.displayName = "AitRowGroupTrafficLight";
